import type { InterleavedSearchRowSelectionMetadata } from "../store/schema/InterleavedSearchResultContext";
import getInterleavedSearchExperimentStore from "../store/store";

export function getInterleavedSearchRowSelectionMetadata(tableViewId: string, instanceKey: string): InterleavedSearchRowSelectionMetadata | undefined {
    const context = getInterleavedSearchExperimentStore().currentInterleavedSearchResultContext;
    if (!context || context.tableViewId !== tableViewId) {
        return undefined;
    }
    
    const rowMetadata = context.rowMetadataByInstanceKey.get(instanceKey);
    return rowMetadata
        ? {
            ...rowMetadata,
            searchSessionGuid: context.searchSessionGuid,
            searchQueryId: context.searchQueryId,
        }
        : undefined;
}
